import { helper } from '@ember/component/helper';

import { toArray } from 'rise-ui/utils/array.js';

export default helper(function limitHelper([ arrayArg, limitArg ], { array, limit, nonArray }) {
  array = array || arrayArg || [];
  limit = limit || limitArg;
  return toArray(array, false, nonArray ? null : []).slice(0, limit);
});
